module.exports = __webpack_public_path__ + "img/info-row-icon.e417bc28.svg";